<template>
    <div id="status"  type='button' :class="{'h-pm-statustemp': true, 'h-pm-e-activecolor': this.$data.data.counterCodeSwitch == active, 'h-pm-e-inactivecolor': this.$data.data.counterCodeSwitch == inactive}">
        <span :class="{'h-pm-e-txt-activecolor': this.$data.data.counterCodeSwitch == active, 'h-pm-e-txt-inactivecolor': this.$data.data.counterCodeSwitch == inactive}">
            {{this.$data.data.counterCodeSwitch2}}
        </span>
    </div>
</template>
<script>

const INACTIVE = 0;
const ACTIVE = 1;
export default {
  name: 'statusTemplate',
  data() {
    return {
      active: ACTIVE,
      inactive: INACTIVE,
    };
  },

};
</script>
